import * as React from "react";
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Typography } from "@material-ui/core";

// CSS
const useStyles = makeStyles((theme) => ({
    root: {
        fontStyle: 'italic',
        color: theme.palette.text.secondary,
    }
 }));

// All the incoming values
interface IProps {
    subTitle: string;
}

// Outgoing functions
interface IDispatch {

}

// Actual Component
export type AllProps = IProps & IDispatch;
export const SubTitle = (props: AllProps) => {
    const classes = useStyles(useTheme());
    return (<Typography className={classes.root} variant="h5" gutterBottom>{props.subTitle}</Typography>)
}